module.exports = __webpack_public_path__ + "img/icon-withdrawal.026b5e81.png";